import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {AppRoutingPreloaderService} from './services/app-routing-preloader.service';

const routes: Routes = [
    {path: '', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)},
    {path: 'settings', loadChildren: () => import('./main-pages/settings/settings.module').then(m => m.SettingsPageModule)},
    {path: 'documents', loadChildren: () => import('./main-pages/documents/documents.module').then(m => m.DocumentsPageModule), data: {preload: true}},
    {path: 'documentsalloperators', loadChildren: () => import('./main-pages/documentsalloperators/documentsalloperators.module').then(m => m.DocumentsAllOperatorsPageModule), data: {preload: true}},
    {path: 'documentsdeviceoperator', loadChildren: () => import('./main-pages/documentsdeviceoperator/documentsdeviceoperator.module').then(m => m.DocumentsDeviceOperatorPageModule), data: {preload: true}},
    {path: 'actions', loadChildren: () => import('./main-pages/actions/actions.module').then(m => m.ActionsPageModule)},
    {path: 'calendar', loadChildren: () => import('./main-pages/calendar/calendar.module').then(m => m.CalendarPageModule)},
    {path: '**', loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)}


];

@NgModule({
    imports: [
        //RouterModule.forRoot(routes, {preloadingStrategy: AppRoutingPreloaderService, useHash: true})
        RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, useHash: true})

    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
